// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"8d105082","506":"748566f8","663":"f642fa83"}[chunkId] + ".chunk.js";
};